
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OnHoldReason } from 'enums/OnHoldReason';
import { Model, ModelProperty } from 'models/Model';


export class OnHoldRequestModel extends Model<OnHoldRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'onHoldRequest.property.companyId' },
		{ name: 'documentNo', type: 'string', languageString: 'onHoldRequest.property.documentNo' },
		{ name: 'brandId', type: 'guid', languageString: 'onHoldRequest.property.brandId' },
		{ name: 'onHoldReason', type: 'OnHoldReason', languageString: 'onHoldRequest.property.onHoldReason' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public documentNo: string;
	public brandId?: string;
	public onHoldReason?: OnHoldReason;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.documentNo = '';
		this.brandId = undefined;
		this.onHoldReason = undefined;
		
	}
	getProperties(){
		return OnHoldRequestModel.classProperties;
	}
}

